let prefetchPromise = null;

/**
 * Warm the lazy `@/app/Websdk` chunk on navigation intent (e.g. header menu open).
 * Safe to call multiple times; only the first call starts the import.
 */
export function prefetchWebsdkShell() {
    if (prefetchPromise) {
        return prefetchPromise;
    }

    prefetchPromise = import(
        /* webpackChunkName: "Websdk" */ '@/app/Websdk'
    ).catch(() => {
        prefetchPromise = null;
    });

    return prefetchPromise;
}
